import { Manifest } from '../types/manifest';

export const EMERGENCY_CONFIG: Manifest = {
  version: '1.0',
  lastUpdated: '2025-01-20T00:00:00Z',
  audioBaseUrl: '/audio',
  languages: {
    vi: {
      name: 'Tiếng Việt (Limited)',
      nativeName: 'Tiếng Việt',
      styles: {
        tet_traditional: {
          name: 'Nhạc Tết',
          description: 'Emergency fallback',
          files: 90,
          previewUrl: null,
        },
      },
    },
  },
  defaults: {
    language: 'vi',
    style: 'tet_traditional',
    min: 1,
    max: 99,
    autoPlayInterval: 5,
  },
};
